module.exports = __webpack_public_path__ + "static/media/grin-tongue-wink.3a3877c8.svg";